import CreateItemButton from "components/buttons/create";
import List from "components/list";
import { PermissionControlledInput } from "permissions/components/input";
import HeaderPortal from "components/portal/header-portal";
import { DateCell } from "@/components/date/cell";

export default function Holidays() {

    const columns = [
        {
            id: "name",
            header: "Name",
            accessorKey: "name",
            sortable: true,
        },
        {
            id: "date",
            header: "Date",
            accessorKey: "date",
            cell: DateCell,
        },
    ];

    const fields = ["id", "name", "date"];


    return (
        <div className="w-full">
            <HeaderPortal>
                <PermissionControlledInput
                    rule={"create:*"}
                    collection="holidays"
                    showWhenDisabled={false}
                >
                    <CreateItemButton href>Holidays</CreateItemButton>
                </PermissionControlledInput>
            </HeaderPortal>
            <div className="flex-1 h-full">
                <List
                    title="Holidays"
                    endPoint="holidays"
                    columns={columns}
                    meta={{
                        fields,
                    }}
                    sortBy="date"
                    sortOrder="aesc"
                    href={(item) => item.id}
                />
            </div>
        </div>
    );
}
